export const CHECK_LAST_REQUEST_TIME = 'CHECK_LAST_REQUEST_TIME';
export const CHECK_LAST_REQUEST_TIME_SUCCESS = 'CHECK_LAST_REQUEST_TIME_SUCCESS';
export const CHECK_LAST_REQUEST_TIME_FAILURE = 'CHECK_LAST_REQUEST_TIME_FAILURE';
